// USA
export const locale = {
  common: {
    homepage: "Home",
    back: "Back",
    video_not_supported: "Sorry, your browser does not support embedded videos",
    detail: "Details",
    list: "List of tools",
    footer: "A site made by Insaniam",
    displayVideo: "Video playing",
    submit: "Send",
    cancel: "Cancel",
    errorOccurred: "An error has occurred",
    cgu: "Terms Of Use",
    browser:
      "Hello, Tell me Genius is not available on Internet explorer. We advise you to use Chrome or another browser. TMG team",
    browserAlert: "Warning",
    user: {
      lastname: "Name",
      firstname: "Firstname",
      email: "Email",
      phone: "Phone",
      company: "Company",
      address: "Address",
    },
    form: {
      required: "The field must be filled in",
      required_field: "The field '%{field}' must be filled in.",
      max_characters: "Maximum number of characters exceeded (%{max} maximum)",
      email_invalid: "The email address entered is invalid.",
      phone_translations: {
        countrySelectorLabel: "Country code",
        countrySelectorError: "Select a country",
        phoneNumberLabel: "Phone number",
        example: "Example:",
      },
    },
  },
  auth: {
    callback: {
      login: "Genius validate your access...",
      logout: "See you soon !",
    },
    errors: {
      invalid_authorizations:
        "Unauthorized authentication. Please contact support or an administrator.",
      invalid_claims:
        "Unauthorized authentication. Please contact support or an administrator.",
      invalid_client:
        "Unauthorized authentication. Please contact support or an administrator.",
      invalid_client_options:
        "Unauthorized authentication. Please contact support or an administrator.",
      invalid_user:
        "Unauthorized authentication. Please contact support or an administrator.",
      invalid_user_session:
        "Unauthorized authentication. Please contact support or an administrator.",
      invalid_parameters:
        "Unauthorized authentication. Please contact support or an administrator.",
      empty_user_roles:
        "Insufficient user roles or rights. Please contact support or an administrator.",
      invalid_claims_roles:
        "Insufficient user rights or roles. Please contact support or an administrator.",
      authentication_failed: "Authentication failed. Please try again.",
      unknown:
        "Authentication failed. Please contact support or an administrator.",
    },
  },
  freemium: {
    quotaReached: {
      title: "Oops.. You have no more video available for this week.",
      message: "You have watched all of your videos available for this week. Please come back soon to watch videos again. Genius reminds you that you can watch <span style='color:#e6057d'>%{videosAuthorized}</span> videos every <span style=\"color:#e6057d\">%{videosPeriod}</span> days.",
    },
    banner : {
      message : "You have <span style=\"color:#e6057d\">%{videosLeft}</span> videos left available.<br><u>Reminder</u>: you have <span style=\"color:#e6057d\">%{videosAuthorized}</span> videos available every  <span style=\"color:#e6057d\">%{videosPeriod}</span> days.",
      button : "Hide",
    }
  },
  home: {
    api: {
      contact_success: {
        title: "Request sent to genius 📬",
        message:
          "Thanks for contacting us.<br>The TellMeGenius.io team will get back to you very soon.",
      },
      contact_failed: {
        title: "Geniius could not receive your request 😢",
        message:
          "You can contact TellMeGenius.io team directly at this address: %{mail} ",
        max_attempt:
          "You have already submitted too many requests to Genius.🤯<br>Try later.",
      },
      register_success: {
        title: "One more step to connect 🥳",
        message:
          "You will receive a validation email  📬<br>Follow instructions in email to validate the creation of your account.",
      },
      register_failed: {
        title: "Genius was unable to create your account. 😢",
        message: "Contact us via our form to help you create your account.",
        unknown_error:
          "An unknown error occured during registration.<br>Contact us via our form at bottom page to help you create your account",
        recaptcha_token_failed:
          "Google services failed to provide a verification token.<br>Contact us via our form to help you create your account.",
        recaptcha_verify_failed:
          "Google services have cancel registration for non-compliance with the registration terms.<br>Contact us via our form to help you create your account.",
        wrong_parameters: "Information provided is incorrect or incomplete.",
        user_already_exist:
          "There is already a user with this e-mail address. Connect directly or enter another e-mail address.",
        user_registration_disabled:
          "New account registration will be possible very soon.",
      },
    },
    demo: {
      button: "Test our solution for free",
    },
    menu: {
      bibliothequeVideos:
        "'<span class='text-primary'>Videos</span>' page allows you to access all available videos. 📽️<br>Search functions will allow you to find the video corresponding to your question.",
      bibliothequeParcours:
        "'<span class='text-primary'>Courses</span>' page allows you to access the different progression pathways offered.<br>They will help you build your skills on a particular topic or process. 🎓",
      bibliothequeThemes:
        "'<span class='text-primary'>Topics</span>' page offers you the possibility to browse through all the video content ordered by topic: handy for finding the video that will help you without having to formulate a search. 🤩",
      posterVideoUser:
        "'<span class='text-primary'>Post Your Videos</span>' page allows you to submit videos you've shot yourself to your entire organization. Handy for sharing your knowledge, right? 👌",
    },
    popup: {
      video_title: "Discover TellMeGenius.io for free",
      video_button: "I register",
      register_title: "Discover TellMeGenius.io for free",
      register_message: "Enjoy all the features and watch up to <span style=\"color:#e6057d\">%{videosAuthorized}</span> videos per week",
      register_disabled:
        "New account creation will be available soon.<br>If you want more information, contact us via the form at the end of the homepage.",
      register_button: "Here we go",
      register_buton_cancel: "Cancel",
      register_accept_condition_label:
        "I agree to be contacted by TellMeGenius.io teams",
      register_accept_condition_mandatory:
        "You must accept the conditions for registration",
      tools_selection_label: "Tool(s) of interest",
    },
    potential: {
      title:
        "Information Systems finally used at <span class='text-primary font-weight-bold'>their full potential</span>",
      subtitle_1:
        "TellMeGenius.io makes information systems <span class='text-primary font-weight-bold'>accessible</span> to users through <span class='text-primary font-weight-bold'>instructional videos</span> made by experts. 🎥",
      subtitle_2:
        "Users find answers to their questions about softwares in less than 5 minutes, on video, regardless of the project stage 👇",
      project_support_title: "Project support",
      project_support_description:
        "In support of project workshops, for optimized communication and information sharing between IT and the business",
      operation_support_title: "Operations support",
      operation_support_description:
        "No more level 1 TMA. Got a question? Answer is instantly and autonomously accessible by video",
      tool_adoption_title: "Tool adoption",
      tool_adoption_description:
        "Software adoption is easier with a strong users engagement",
      change_management_title: "Change management",
      change_management_description:
        "Less resistance to change. Changes in softwares or processes are easily assimilated by users",
      training_title: "Training",
      training_description: "Softwares and process self-training",
    },
    tools: {
      title:
        "Which tools are being covered in <span class='text-primary font-weight-bold'>videos</span>?",
    },
    community: {
      title:
        "Join the <span class='text-primary font-weight-bold'>Tellers community</span> 🚀",
      subtitle_1:
        "Experts on Information Systems, they produce videos and assist in realization of tailor-made contents.",
      subtitle_2:
        "Key accounts and SMEs: they trust us and maximize the potential of their information systems thanks to TellMeGenius.io",
    },
    bosco: {
      title: "TellMeGenius.io, a Bosco Technologies solution",
      subtitle_1:
        "Bosco Technologies is specialized in EPM expertise. With years of experience in supporting financial departments, we are now developing our activity around 3 axes:",
      list_1: "EPM projects direction",
      list_2: "Interventions for projects owners and entities in charge of the implementation",
      list_3: "Softwares publisher of expertise management solutions",
      star: "Our North Star",
      team: "Team",
    },
    contact: {
      button: "Contact us",
      comment: "A question? A comment? Don't hesitate to write it here",
      tools: "The tools/themes that interest you",
    },
  },
  video: {
    player: {
      shortcut: {
        space: "Space",
        upArrow: "Up Arrow",
        basArrow: "Down Arrow",
        rightArrow: "Right Arrow",
        leftArrow: "Left Arrow",
      },
      play: "Lecture",
      pause: "Pause",
      mute: "Mute",
      unmute: "Unmute",
      back: "Back",
      forward: "Forward",
      pip: "PIP",
      pipNotSupported: {
        title: "Manual action on Firefox required",
        html: "Genius needs you to enable Picture in Picture mode on Firefox.<br>Right click on the video, and click on 'Picture-in-Picture'.",
        button : "<i class='fa fa-thumbs-up'></i> Ok !",
      },
      fullscreen: "Fullscreen",
      exitFullscreen: "Exit Fullscreen",
      autoplay: {
        label: "Autoplay",
        activated: "Autoplay enabled",
        desactivated: "Autoplay disabled",
      },
      nextVideoMessage: "Next video in",
      nextVideoSeconds: "second(s)",
      resumeMessage: "Playback is continued from where it was paused",
    },
    otherVideos: "You may also be interested in: ",
    courses:
      "No course containing the video | One course contains the video | {count} courses containing the video:",
    keyword: "Keywords",
    tag: "No tag",
    views: "views",
  },
  theme: {
    selectPlaceholder: "Select your software",
    //page > theme > contentVideo
    title:
      'No video in theme "%{param}" | One video in theme "%{param}" | {count} videos in theme "%{param}"',
    //admin > theme > forms > tabs > themesUser
    subTitle:
      "No video in to software | One video in to software | {count} videos in to software",
    text: "Up to you to explore !",
    text2: "No video to display",
  },
  course: {
    //videosInCourse: "No videos viewed out of {total} in this course | One video viewed out of {total} in this course | {count} videos viewed out of {total} in this course",
    videosInCourse:
      "No video watched yet | One video viewed out of {total} in this course | {count} videos out of {total} already watched",
    start: "Courses",
    start2: "in progress",
    nostart: "Courses",
    nostart2: "to discover",
    //page > course > contentVideo
    title:
      'No video in the course "%{param}" | One video in the course "%{param}" | {count} videos in the course "%{param}"',
    videoSuivante: "Next video",
    videoPrecedente: "Previous video",
    all: "All courses",
    all2: "",
  },
  wish: {
    noSearchResultsL1: "We haven't found any videos matching your search",
    noSearchResultsL2: "Is it complete ? Have you tried other keywords ? ",
    noSatifyingResult: "None of these videos match your search ?",
    noSatifyingResultTheme: "No theme or video matches your search ?",
    noSatifyingVideo: "This video does not meet your expectations ?",
    wish: "Tell us what you would have liked to find",
    wishButton: "by clicking here",
    placeholderTextArea: "Tell us what you would have liked to find",
    labelAllowContact:
      "I agree to be contacted by the TellMeGenius.io team after sending this message",
    submitWish: "Sending",
    errors: {
      empty: "Please make a request",
      short:
        "TellMeGenius needs a complete request to improve its service (min. 30 characters)",
      exceed: "The request cannot exceed 500 characters",
    },
    submit: {
      title: "Request to the Genius",
      successText:
        "Your request has been sent the Genius. It will soon be analysed by him and his team",
      errorText:
        "Your wish could not be sent to the Genius. Please contact a member of the team directly at this address: contact@tellmegenius.io.",
    },
  },
  search: {
    placeholder: "What are you looking for? Word, expression, question …?",
    noResults: "Genius could not find any results.",
    noResultsL2: "Is your search complete ?",
  },
  upload: {
    title: "Post your own videos",
    desc1: "Post here videos you want to find on your Tell Me Genius account",
    desc2: "They will only be visible to your teams and yourself",
    instr1: "Drag a file or click here to add it",
    info1: "Supported extensions:",
    info2: "Maximum size:",
    info3: "File name:",
    info4: "File size (bytes) :",
    info5: "Extension :",
    send: "Send",
    afterSend: "File added!",
    afterSendOption: "Delete",
    mimeTypes: "Please choose an archive in .zip format",
    fileMaxSizeError: "Your archive cannot exceed 1 GB",
  },
  sidebar: {
    videosMenu: "Videos",
    coursesMenu: "Courses",
    themesMenu: "Themes",
    posteVideosMenu: "Upload your videos",
    adminMenu: "Admin",
    actionsRapidesMenu: "Quick actions",
  },
  sortingMenu: {
    tooltip : "Videos order",
    date : "Date",
    view : "View",
    alpha : "Alphabetical",
    pertinence: "Relevance",
    order : {
      asc: "Ascending order",
      desc : "Descending order"
    }
  },
  adminPanel: {
    title: "Admin area",
    content: "Content management",
    client: "Clients management",
    clientContent: "Client's content management",
    bosco: "Bosco's account management",
    partners: "Partners management",
    KPI: "KPI Visualization",
    notification: "Notification Management",
  },
  quickActionsPanel: {
    contentTitle: "Content",
    addTheme: "Create theme",
    addVideo: "Create video",
    addCourse: "Create course",
    clientTitle: "Clients",
    addClient: "Create client",
    addUserRight: "Create user right",
    addUser: "Create user",
  },
  quickUser: {
    title: "My profile",
    firstname: "Firstname",
    name: "Name",
    client: "Business",
    email: "email",
    logout: "Sign out",
    emailText: "please enter your email address",
    initializeMdp: "Change your password?",
    reset: "Reset",
    toolList: "Software(s)",
    noToolFound: "No software found",
    contactUs: "Contact us",
    role: "Function",
    changePassword: "Change password",
  },
  welcome: {
    hello: "Hello",
  },
  breadCrumb: {
    dashboard: "Dashboard",
  },
  login: {
    welcome: "Welcome on TellMeGenius",
    access: "Access my account",
    text: "BECOME EXPERTS IN YOUR SOFTWARE",
    email: "Email",
    password: "Password",
    passwordConfirm: "Confirm Password",
    forgot: "Forgot password?",
    forgotText:
      "We have received your request after forgetting your password. If your email is known to our services, an email to reset it has been sent to you.",
    forgotTextQuickUser:
      "An email has been sent to you to change your password",
    forgotSuccess:
      "Your password request has been handle successfully. Please, check your email inbox.",
    signIn: "Sign in",
    emailRequired: "Email is required",
    passwordRequired: "Password is required",
    confirmPasswordRequired: "Confirm password is required",
    passwordsDoesntMath: "The password and its confirm are not the same",
    incorrectData: "Please, provide correct data!",
    reset: "Reset password",
    resetText: "Type in your new password",
    tokenIncorrect: "Your password request has expired",
    invalidCredentials: "Invalid credentials",
  },
  modal: {
    welcome: "Welcome !",
    textModal1: "You are now on your personal TellMeGenius user account.",
    textModal2: "First of all, we invite you to watch the discovery course",
    textModal3:
      "to discover our short starter guide on video. It will help you to understand the platform and will",
    textModal4: "give you tips and tricks to better use it.",
    textModal5: "You will find this course bellow, by clicking on the button.",
    textModal6: "It is made up of a few videos that you can watch in order by ",
    textModal7: "clicking on “next video” each time a video is finished.",
    textModal8: "Have a nice viewing and enjoy TellMeGenius!",
    click: "Let's go!",
  },
  404: {
    title: "Oops... 404 error",
    text:
      "We're sorry, the page you are looking for does not exist or no longer exists.",
  },
  cockpit: {
    summary : {
      title: "Summary",
      subtitle: "Overview of Tellmegenius.io Usage by Members of Your Organization",
      activeUsers: "Users Who Have Logged In At Least Once vs. Users Created",
      connections: "Total Number of Logins to Tellmegenius.io by Your Users",
      videoViews: "Total Number of Videos Viewed by Your Users",
      courseViews: "Total Number of Courses Completed by Your Users",
      topUserTitle: "User who watched the most content",
      topUserViews: "video views",
    }
    
  },
  editMultipleUserRights: {
    title: "Bulk Edit User Rights",
    selectedUsers: "Selected User Rights",
    themesManagement: "Themes Management",
    modifyThemesBtn: "Modify Themes",
    selectedThemesTitle: "Select Theme",
    selectedThemes: "Selected Themes",
    selectedCount: "theme(s) selected",
    noThemesSelected: "No theme selected",
    clickToAddThemes: "Click \"Modify Themes\" to add themes",
    associatedRights: "Associated Rights",
    associatedCount: "right(s) associated",
    noAssociatedRights: "No rights associated with this theme",
    themeAssociatedSubtitle: "This theme will be associated with all selected rights",
    resetBtn: "Reset",
    validateBtn: "Validate",
    viewAssociatedRights: "View Associated Rights",
    name: "Name",
    successUpdate: "All user rights have been updated.",
    errorUpdate: "An error occurred while updating user rights"
  }
};
